import { render, staticRenderFns } from "./ProductSortFilter.vue?vue&type=template&id=50edf7b0&scoped=true&"
import script from "./ProductSortFilter.vue?vue&type=script&lang=js&"
export * from "./ProductSortFilter.vue?vue&type=script&lang=js&"
import style0 from "./ProductSortFilter.vue?vue&type=style&index=0&id=50edf7b0&prod&scoped=true&lang=scss&"
import style1 from "./ProductSortFilter.vue?vue&type=style&index=1&id=50edf7b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50edf7b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VSelect})
